<template>
    <div class="glogo">
        <van-row>
            <van-col span="24">
                <Header :title="title"></Header>
            </van-col>
        </van-row>
        <van-row class="logo">
            <van-col span="24">
                <van-image
                        width="180px"
                        height="150px"
                        fit="contain"
                        :src= logo
                />
            </van-col>
        </van-row>
        <van-row>
            <van-col span="24">
                <van-form @submit="onSubmit"
                          validate-first
                          :show-error = "false"
                          :show-error-message = "false"
                          @failed="onFailed" >
                    <van-field
                            v-model="phone"
                            type="number"
                            name="phone"
                            :label='$t( "login.phone" )'
                            :placeholder='$t( "login.phone" )'
                            :rules="[{ pattern, message: this.$t('login.phone_msg') }]"
                    />
                    <van-field
                            v-model="password"
                            type="password"
                            name="password"
                            :label='$t( "login.password" )'
                            :placeholder='$t( "login.password" )'
                            :rules="[{ pattern:/.{6}/, message: this.$t('login.pass_msg') }]"
                    />
                    <div style="margin: 16px;">
                        <van-button color="linear-gradient(to right, #ff6034, #ee0a24)" block type="info" native-type="submit">{{ $t('login.login')}}</van-button>
                    </div>
                </van-form>
            </van-col>
        </van-row>
        <van-row class="regbtn">
            <router-link to="Forget"><van-col span="12">{{$t("login.Forget")}}</van-col></router-link>
            <router-link to="Reg"><van-col span="12">{{$t("login.Reg")}}</van-col></router-link>
        </van-row>
        <van-row class="foot">
            <van-col span="24">{{ $t('login.agreement')}}</van-col>
        </van-row>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    export default {
        name: "Login",
        data(){
            return{
                title:this.$t('login.login'),
                logo:require('../assets/images/ic_login_logo.png'),
                phone:'',
                password:'',
                pattern:/\d{6}/,
            }
        },
        methods: {
            onSubmit(values) {
                //console.log('submit', values);
                if(values){
                    this.postReq('/login',values).then(res=>{
                        if(res.code ==0){
                            const tokenStr = res.data.tokenStr;
                            window.localStorage.setItem('tokenStr',tokenStr);
                            //跳转
                            this.$router.replace('/');
                        }
                    })
                }
            },
            onFailed(errorInfo) {
                if(errorInfo.errors[0]){
                    this.$toast({
                        message : errorInfo.errors[0].message,
                        position : 'top'
                    })
                }
            }
        },
        components:{
            Header
        }
    }
</script>

<style scoped lang="scss">
    .glogo{
        background: white;
        .logo{

        }
        .regbtn{
            margin: 30px auto;
        }
        .foot{
            margin: 30px auto;
        }
    }
</style>
